export default {
  _widgetLabel: 'MapKomponente',
  chooseSelectionClick: 'Wählen Sie das zu selektierende Objekt aus',
  chooseGrafic: 'Welche Grafik möchten Sie auswählen?',
  graphicSelectorSelect: 'Auswählen',
  graphicSelectorAbort: 'Abbrechen',
  graphicSelectorDefaultListItem: 'Unbennante Grafik',
  graphicSelectorDeselect: 'Abwählen',
  graphicSelectorTT: 'Auswahl durch Klick auf den Button',
  loadingIndicatorText: 'Layer werden eingebunden und Geometrien geladen.',
  selectionIndicatorText:
    'Die Grafiken für die Selektion werden vom Server abgerufen.',
};
